export const DollarsToCents = (amount) => {
    return Math.round(Number(amount) * 100)
};

export const CentsToDollars = (amount) => {
    return (Number(amount) / 100).toFixed(2);
};
